module.exports = __webpack_public_path__ + "static/img/to_elite_game.108cbf32.png";